import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=aa8a5e92&scoped=true&"
import script from "./VSelect.vue?vue&type=script&lang=js&"
export * from "./VSelect.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./VSelect.vue?vue&type=style&index=0&id=aa8a5e92&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "aa8a5e92",
  null
  ,true
)

export default component.exports